import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import ReactPlayer from "react-player";
import "@/assets/styles/Utils.css";

export function ProgramModal(props) {
  // const [feedbackLvl, setLvl] = useState(5);
  // const [feedbackText, setFeedbackText] = useState("");
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Programm als Slideshow
        </Modal.Title>
      </Modal.Header>
      <Carousel activeIndex={index} onSelect={handleSelect}>
        {props.exercises.map((exercise, index) => (
          <Carousel.Item key={index}>
            <ReactPlayer
              url={exercise.props.exercise.source.video_url}
              width="100%"
              pip={true}
              // muted
              controls={true}
              playing={true}
              autoplay
            />
            <Carousel.Caption>
              <h3>{exercise.props.exercise.source.video_url}</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </Modal>
  );
}
